import React, { useState } from 'react';
import {
  Button,
  CheckPicker,
  Form,
  Stack,
} from 'rsuite';
import { Partner } from '../../api/partner/partnerApiTypes';
import {
  RoleOption, UsersFilter, initialUsersFilter, trimUsersFilter,
} from './usersState';

interface Props {
  visible: boolean;
  partners: Partner[];
  roleOptions: RoleOption[];
  onApply: (filter: UsersFilter) => void;
}

export default function UsersFilterForm({
  visible, partners, roleOptions, onApply,
}: Props): JSX.Element | null {
  const [formValue, setFormValue] = useState<UsersFilter>(initialUsersFilter);

  const partnerOptions = partners.map(partner => ({
    label: `${partner.code} - ${partner.name}`,
    value: partner.code,
  }));

  function handleApply(): void {
    const trimmedFilter = trimUsersFilter(formValue);

    setFormValue(trimmedFilter);
    onApply(trimmedFilter);
  }

  function handleReset(): void {
    setFormValue(initialUsersFilter);
    onApply(initialUsersFilter);
  }

  if (!visible) {
    return null;
  }

  return (
    <Form
      layout="vertical"
      className="mt-20"
      formValue={formValue}
      onChange={value => setFormValue(value as UsersFilter)}
    >
      <Stack spacing={40} alignItems="flex-start">
        <Stack direction="column" spacing={10} alignItems="stretch">
          <Form.Group controlId="name">
            <Form.ControlLabel>Name</Form.ControlLabel>
            <Form.Control name="name" placeholder="Exact name" style={{ width: 300 }} />
          </Form.Group>
          <Form.Group controlId="username">
            <Form.ControlLabel>Username</Form.ControlLabel>
            <Form.Control name="username" placeholder="Exact username" style={{ width: 300 }} />
          </Form.Group>
        </Stack>
        <Stack direction="column" spacing={10} alignItems="stretch">
          <Form.Group controlId="partnerCodes">
            <Form.ControlLabel>Partners</Form.ControlLabel>
            <Form.Control
              name="partnerCodes"
              accepter={CheckPicker}
              data={partnerOptions}
              style={{ width: 300 }}
            />
          </Form.Group>
          <Form.Group controlId="roles">
            <Form.ControlLabel>Roles</Form.ControlLabel>
            <Form.Control
              name="roles"
              accepter={CheckPicker}
              data={roleOptions}
              searchable={false}
              style={{ width: 300 }}
            />
          </Form.Group>
        </Stack>
      </Stack>
      <Stack spacing={10} className="mt-10">
        <Button appearance="primary" onClick={() => handleApply()}>
          Filter
        </Button>
        <Button appearance="primary" onClick={() => handleReset()}>
          Clear
        </Button>
      </Stack>
    </Form>
  );
}
